import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Form, Header, Segment } from 'semantic-ui-react';
import { toast } from 'react-semantic-toasts';
import history from '../../../../utils/history';
import request from '../../../../utils/request';

const { Button, Group, Input } = Form;

class AdminTagsListView extends React.Component
{
    state = {
        errors: {},
        tag: {},
    };

    /**
     * Mount
     */
    componentDidMount = () => {
        if (this.props.match.params.id) {
            this.fetch();
        }
    }

    /**
     * Fetch
     */
    fetch = () => {
        request(`admin/tags/${this.props.match.params.id}`).then(({ data }) => {
            this.setState({
                tag: data,
            });
        });
    }

    /**
     * Handle input
     */
    handleInput = (e, { name, value }) => {
        const { errors, tag } = this.state;

        this.setState({
            errors: {
                ...errors,
                [name]: false,
            },
            tag: {
                ...tag,
                [name]: value,
            },
        });
    }

    /**
     * Save
     */
    handleSubmit = () => {
        const { id } = this.props.match.params;
        const { tag } = this.state;

        request[id ? 'patch' : 'post'](`admin/tags${id ? `/${id}` : ''}`, tag).then(() => {
            toast({
                type: 'success',
                icon: '',
                description: 'Tag saved succesfully',
                time: 2500,
            });
            history.push('/admin/tags');
        }).catch((error) => {
            toast({
                type: 'error',
                icon: '',
                title: 'Something went wrong',
                description: 'Please check all required fields',
                time: 2500,
            });

            this.setState({
                ...this.state,
                errors: error.response.data.errors,
            });
        });
    }

    // --- render
    render() {
        const { errors, tag } = this.state;

        return (
            <Container className="admin-page">
                <Segment padded>
                    <div className="admin-page-header">
                        <Header as="h1">{tag.id ? 'Edit' : 'Create'} tag</Header>
                        <Link to="/admin/tags">Back</Link>
                    </div>
                    <Form onSubmit={this.handleSubmit}>
                        <Input
                            error={errors.name && errors.name !== false}
                            label="Name"
                            name="name"
                            onChange={this.handleInput}
                            required
                            value={tag.name}
                        />
                        <Group>
                            <Button primary>Save</Button>
                            <Link to="/admin/tags" style={{ marginTop: 9, marginLeft: 10 }}>Cancel</Link>
                        </Group>
                    </Form>
                </Segment>
            </Container>
        );
    }
}

export default AdminTagsListView;
